<template>
  <div style="margin-top: 3rem;">

    <!-- https://unsplash.com/photos/w2JtIQQXoRU -->

    <div>
      <b-img src="/public/downloads/directories/images/clock2.jpg" fluid alt="Clock"></b-img>
    </div>
    <br/>
    <br/>
    <h2>Bereits jetzt feststehende Termine</h2>

    <br/>
    <p>
      <b-list-group>
        <b-list-group-item>Flammkuchenessen</b-list-group-item>
      </b-list-group>
    </p>
    <br/>

    <br/>
    <br/>
    <h2>Termine im Wintersemester 2024/2025</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsWS24" :fields="fieldsWS24"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>

    <br/>
    <br/>
    <h2>Termine im Sommersemster 2024</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsSS24" :fields="fieldsSS24"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>

    <br/>
    <br/>
    <h2>Termine im Wintersemester 2023/2024</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsWS23" :fields="fieldsWS23"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>

    <br/>
    <br/>
    <h2>Termine im Sommersemester 2023</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsSS23" :fields="fieldsSS23"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>

    <br/>
    <br/>
    <h2>Termine im Wintersemester 2022/2023</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsWS22" :fields="fieldsWS21"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>

    <br/>
    <br/>
    <h2>Termine im Sommersemster 2022</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsSS22" :fields="fieldsSS22"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>
    <h2>Termine im Wintersemster 2021/2022</h2>
    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsWS21" :fields="fieldsWS21"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>
    <br/>
    <br/>
    <h2>Termine im Sommersemester 2021</h2>
    <br/>
    <p>Aufgrund der Corona-Pandemie haben wir uns dazu entschlossen, alle geplanten Termine im Sommersemester 2021
      abzusagen.</p>
    <br/>
    <p>Einzelne Treffen wie Aktivenconvente werden kurzfristig bekanntgegeben.</p>
    <br/>
    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsSS21" :fields="fieldsSS21"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>
    <br/>
    <br/>
    <h2>Termine im Wintersemester 2020/2021</h2>
    <br/>
    <p>Aufgrund der Corona-Pandemie haben wir uns dazu entschlossen, alle geplanten Termine im Wintersemester 2020/2021
      abzusagen.</p>
    <br/>
    <p>Einzelne Treffen wie Aktivenconvente werden kurzfristig bekanntgegeben.</p>
    <br/>
    <br/>
    <h2>Termine im Sommersemester 2020</h2>
    <br/>
    <p>Aufgrund der Corona-Pandemie haben wir uns dazu entschlossen, alle geplanten Termine im Sommersemester 2020
      abzusagen.</p>
    <br/>
    <p>Einzelne Treffen wie Aktivenconvente werden kurzfristig bekanntgegeben.</p>
    <br/>
    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsSS20" :fields="fieldsSS20"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>
    <br/>
    <br/>
    <h2>Termine im Wintersemster 2019/2020</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsWS19" :fields="fieldsWS19"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>

    <br/>
    <br/>
    <h2>Termine im Sommersemster 2019</h2>

    <br/>
    <p>Zu den mit <span style="color:red;">&hearts;</span> gekennzeichneten Veranstaltungen sind auch Damen herzlich
      willkommen.</p>
    <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="itemsSS19" :fields="fieldsSS19"
    >
      <span slot="veranstaltung" slot-scope="data" v-html="data.value"></span>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fieldsWS24: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsWS24: [
        {id: 1, datum: '27.09.2024 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 2,
          datum: '27.09.2024 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>zur Linde</i>',
          bemerkung: ''
        },
        {id: 3, datum: '12.10.2024', veranstaltung: 'Besuch des  <i>Cannstatter Wasn</i> (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 4, datum: '26.10.2024 20 Uhr', veranstaltung: 'Herbstpunch <i>im Hause Bretschneider</i> (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 5, datum: '01.11.2024 - 03.11.2024', veranstaltung: 'Aktivenfahrt zur <i>B! Derendingia zu Tübingen</i>', bemerkung: ''},
        {id: 6, datum: '23.11.2024 17:00 Uhr', veranstaltung: 'CC im Restaurant <i>Schlindweinstuben</i>', bemerkung: 'in Karlsdorf'},
        {
          id: 7,
          datum: '23.11.2024 20 Uhr',
          veranstaltung: 'Gründungstagskommers im Restaurant <i>Schlindweinstuben</i>', bemerkung: 'in Karlsdorf'},
        {id: 8, datum: '24.11.2024 11 Uhr', veranstaltung: 'Gräbergang', bemerkung: 'Treffpunkt Haupteingang Friedhof Bruchsal'},
        {
          id: 9,
          datum: '24.11.2024 13 Uhr',
          veranstaltung: 'gemeinsames Mittagessen im Restaurant <i>Neo</i>',
          bemerkung: ''
        },
        {
          id: 10,
          datum: '14.12.2024 19 Uhr',
          veranstaltung: 'Weihnachtsmarktbesuch <i>Weihnachtsmarkt Karlsruhe</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 11,
          datum: '20.12.2024 18 Uhr',
          veranstaltung: 'Weihnachtsessen im Restaurant <i>Belvedere</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 12, datum: '11.01.2025 19 Uhr', veranstaltung: 'Neujahrskegeln mit gem. Abendessen (<span style="color:red;">&hearts;</span>)', bemerkung: 'Kegelverein Ubstadt'},
        {id: 13, datum: '15.02.2025', veranstaltung: 'Kleiner Kartelltag des PKB im Restaurant <i>Belvedere</i>', bemerkung: ''},
        {id: 14, datum: '21.02.2025 13 Uhr', veranstaltung: 'Besuch des <i>Dampfkraftwerks</i> (<span style="color:red;">&hearts;</span>)', bemerkung: 'Karlsruhe'},
        {id: 15, datum: '21.02.2025', veranstaltung: 'Gemeinsames Abendessen im Braugasthaus <i>Erste Fracht</i> (<span style="color:red;">&hearts;</span>)', bemerkung: 'Karlsruhe'},
        {id: 16, datum: '21.03.2025 19 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 17,
          datum: '21.03.2025 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>zur Linde</i>',
          bemerkung: ''
        }
      ],
      fieldsSS24: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsSS24: [
        {id: 1, datum: '12.04.2024 17 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 2, datum: '12.04.2024 18 Uhr', veranstaltung: 'Kaminabend', bemerkung: ''},
        {id: 3, datum: '12.04.2024 20 Uhr', veranstaltung: 'Semesterantrittskneipe im Restaurant <i>Belvedere</i>', bemerkung: ''},
        {id: 4, datum: '20.04.2024 gt.', veranstaltung: 'Besuch Frühlingsfest (<span style="color:red;">&hearts;</span>)', bemerkung: 'Stuttgarter Frühlingsfest'},
        {id: 5, datum: '27.04.2024 gt.', veranstaltung: '200. Stiftungsfest <i>PV Markomannia 1824 zu Rastatt</i>', bemerkung: 'Festkommers Badner Halle Rastatt'},
        {id: 6, datum: '17.05.2024 17 Uhr', veranstaltung: 'AC/BC im <i>Irish Pub</i>', bemerkung: ''},
        {id: 7, datum: '10.06.2024 18 Uhr', veranstaltung: 'AC/BC im <i>Irish Pub</i>', bemerkung: ''},
        {id: 8, datum: '14.06.-16.06.2024', veranstaltung: 'Aktivenfahrt nach Würzburg', bemerkung: 'Corps Rhenania Würzburg'},
        {id: 9, datum: '22.06.2024 gt.', veranstaltung: 'Familientag mit Stadtführung (<span style="color:red;">&hearts;</span>)', bemerkung: 'in Heidelberg'},
        {id: 10, datum: '29.06.2024 20 Uhr', veranstaltung: 'Großer Kartelltag in Rastatt', bemerkung: ''},
        {id: 11, datum: '06.07.2024 (?)', veranstaltung: 'PKB-Fussballturnier', bemerkung: ''},
        {id: 12, datum: '14.07.2024 09 Uhr', veranstaltung: 'Fahrradtour zum Speyrer Dom (<span style="color:red;">&hearts;</span>)', bemerkung: 'Mittagessen in der Hausbrauerei Domhof'},
        {id: 13, datum: '19.07.2024 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 14, datum: '19.07.2024 20 Uhr', veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>Linde</i>', bemerkung: ''},
        {id: 15, datum: '10.08.2024 17 Uhr', veranstaltung: 'Familien-Grillfest (<span style="color:red;">&hearts;</span>)', bemerkung: 'Grillhütte Forst'},
      ],
      fieldsWS23: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsWS23: [
        {id: 1, datum: '22.09.2023 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 2, datum: '22.09.2023 20 Uhr', veranstaltung: 'Semesterantrittskneipe im Restaurant <i>Belvedere</i>', bemerkung: ''},
        {id: 3, datum: '20.10.2023 17 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 4, datum: '21.10.2023 20 Uhr', veranstaltung: 'Herbstpunch <i>im Hause Bretschneider</i> (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 5, datum: '03.11.2023 - 05.11.2023', veranstaltung: 'Aktivenfahrt zur <i>L! Ghibellinia zu Tübingen</i>', bemerkung: ''},
        {id: 6, datum: '25.11.2023 16:30 Uhr', veranstaltung: 'CC im Restaurant <i>Belvedere</i>', bemerkung: ''},
        {
          id: 7,
          datum: '25.11.2023 20 Uhr',
          veranstaltung: 'Gründungstagskommers im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {id: 8, datum: '26.11.2023 11 Uhr', veranstaltung: 'Gräbergang', bemerkung: 'Treffpunkt Haupteingang Friedhof Bruchsal'},
        {
          id: 9,
          datum: '26.11.2023 13 Uhr',
          veranstaltung: 'gemeinsames Mittagessen im Restaurant <i>Wallhall</i>',
          bemerkung: ''
        },
        {
          id: 10,
          datum: '17.12.2023 19 Uhr',
          veranstaltung: 'Weihnachtsessen im Restaurant <i>Lago</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 11,
          datum: '22.12.2023 19 Uhr',
          veranstaltung: 'Weihnachtsmarktbesuch <i>Weihnachtsmarkt Bruchsal</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 12,
          datum: '14.01.2024',
          veranstaltung: 'Exkursion <i>Planetarium Mannheim</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 13,
          datum: '14.01.2024',
          veranstaltung: 'gemeinsames Essen im Restaurant <i>Alter Simpl</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 14, datum: '01.02.2024 - 04.02.2024', veranstaltung: 'Skiwochenende', bemerkung: 'unter der Leitung von AH Bretschneider'},
        {id: 15, datum: '17.02.2024', veranstaltung: 'Kleiner Kartelltag des PKB in <i>Rastatt</i>', bemerkung: ''},
        {id: 16, datum: '22.02.2024 19 Uhr', veranstaltung: 'Stammtisch im Restaurant <i>Zum Engel</i>', bemerkung: ''},
        {id: 17, datum: '16.03.2024 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 18,
          datum: '16.03.2024 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>zur Linde</i>',
          bemerkung: ''
        },
      ],
      fieldsSS23: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsSS23: [
        {id: 1, datum: '31.03.2023 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 2,
          datum: '31.03.2023 20 Uhr',
          veranstaltung: 'Semesterantrittskneipe im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {id: 3, datum: '23.04.2023 10 Uhr', veranstaltung: '<i>Museumsbesuch</i> im Schloss Karlsruhe (<span style="color:red;">&hearts;</span>)', bemerkung: 'Treffpunkt Bahnhof Bruchsal'},
        {
          id: 4,
          datum: '05.05.2023 - 07.05.2023',
          veranstaltung: 'PV Bund Hüttenwochenende der Aktivitas am <i>Feldberg</i>',
          bemerkung: ''
        },
        {id: 5, datum: '21.05.2023 12 Uhr', veranstaltung: 'Wanderung im Elsass (<span style="color:red;">&hearts;</span>)', bemerkung: 'Treffpunkt Schlossparkplatz'},
        {id: 6, datum: '21.05.2023 18 Uhr', veranstaltung: 'Flammkuchenessen im Restaurant <i>Le Couronne de Roeschwoog</i> (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 7, datum: '17.06.2023 18 Uhr', veranstaltung: 'PV-Bund Grillfest (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 8, datum: '17.06.2023 19 Uhr', veranstaltung: 'Stammtisch <i>Gasthaus zum Engel</i>', bemerkung: ''},
        {id: 9, datum: '30.06.2023', veranstaltung: 'Begrüßungsabend im <i>Archiv Rastatt</i> (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 10, datum: '01.07.2023', veranstaltung: 'Kulturprogramm in <i>Baden-Baden</i> (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 11, datum: '01.07.2023 20 Uhr', veranstaltung: 'Festkommers im Gasthaus <i>Blume in Balg</i>', bemerkung: ''},
        {id: 11, datum: '02.07.2023', veranstaltung: 'Ausklang (<span style="color:red;">&hearts;</span>)', bemerkung: ''},
        {id: 12, datum: '14.07.2023 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 13,
          datum: '14.07.2023 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
      ],
      fieldsWS22: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsWS22: [
        {id: 1, datum: '24.09.2022 ganztägig', veranstaltung: 'Aktiventag', bemerkung: ''},
        {id: 2, datum: '30.09.2022 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 3,
          datum: '30.09.2022 20 Uhr',
          veranstaltung: 'Semesterantrittskneipe im Restaurant <i>Zur Linde</i>',
          bemerkung: ''
        },
        {
          id: 4,
          datum: '23.10.2022 10 Uhr',
          veranstaltung: 'Exkursion nach <i>Straßburg</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 5, datum: '19.11.2022 17 Uhr', veranstaltung: 'CC im Restaurant <i>Belvedere</i>', bemerkung: ''},
        {
          id: 6,
          datum: '19.11.2022 ab 18 Uhr',
          veranstaltung: 'gemeinsames Abendessen im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {
          id: 7,
          datum: '19.11.2022 20 Uhr',
          veranstaltung: 'Gründungstagskommers im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {id: 8, datum: '20.11.2022 11 Uhr', veranstaltung: 'Gräbergang', bemerkung: ''},
        {
          id: 9,
          datum: '20.11.2022 13 Uhr',
          veranstaltung: 'gemeinsames Mittagessen im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {
          id: 10,
          datum: '03.12.2022 19 Uhr',
          veranstaltung: 'Herbstpunch <i>im Hause Grauer</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 11,
          datum: '18.12.2022 19 Uhr',
          veranstaltung: 'Weihnachtsessen im Gasthof <i>Grombacher Stuben</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 12,
          datum: '23.12.2022 17 Uhr',
          veranstaltung: 'Weihnachtsmarktsbesuch (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 13,
          datum: '08.01.2023 ganztägig',
          veranstaltung: 'Neijahrswanderung (Schneewanderung im Schwarzwald) (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 14, datum: '25.02.2023 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 15,
          datum: '25.02.2023 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {id: 16, datum: '04.03.2023', veranstaltung: 'Kleiner Kartelltag des PKB in <i>Rastatt</i>', bemerkung: ''},
        {id: 17, datum: '09.03.2023 - 12.03.2023', veranstaltung: 'Skiwochenende', bemerkung: ''},
      ],
      fieldsSS22: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsSS22: [
        {id: 1, datum: '01.04.2022 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 2,
          datum: '01.04.2022 20 Uhr',
          veranstaltung: 'Semesterantrittskneipe im Restaurant <i>Zur Linde</i>',
          bemerkung: ''
        },
        {
          id: 3,
          datum: '16.04.2022 11 Uhr',
          veranstaltung: 'Aktiventag <i>unter der Leitung unseres Bbr. Kai Burger</i>',
          bemerkung: ''
        },
        {
          id: 4,
          datum: '07.05.2022 11 Uhr',
          veranstaltung: 'Exkursion ins Elsass (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 5,
          datum: '07.05.2022 17 Uhr',
          veranstaltung: 'Flammkuchenessen im Restaurant <i>la Couronne</i> in Roeschwoog (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Anmeldung erforderlich'
        },
        {
          id: 6,
          datum: '21.05.2022 10 Uhr',
          veranstaltung: 'Pfalzfahrt <i>in Begleitung der Turnerschaft Rhenopalatia</i>',
          bemerkung: ''
        },
        {id: 7, datum: '29.05.2022 10 Uhr', veranstaltung: 'Fahrradtour zum Speyrer Dom', bemerkung: ''},
        {id: 8, datum: '29.05.2022 13 Uhr', veranstaltung: 'Einkehr im Restaurant<i>Domhof</i>', bemerkung: ''},
        {id: 9, datum: '07.06.2022 18 Uhr', veranstaltung: 'AC/BC im Hause Bretschneider', bemerkung: ''},
        {
          id: 10,
          datum: '16.06.-18.06.2022',
          veranstaltung: 'Aktivenfahrt nach Tübingen zu Gast bei <i>L! Ghibellinia zu Tübingen</i>',
          bemerkung: ''
        },
        {
          id: 11,
          datum: '25.06.2019 20 Uhr',
          veranstaltung: 'Großer Kartelltag im Restaurant <i>Brückenhof</i>',
          bemerkung: ''
        },
        {
          id: 12,
          datum: '02.07.2022 11 Uhr',
          veranstaltung: 'Weinwanderung mit anschließender Weinprobe im Weingut <i>Christmann</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Anmeldung erforderlich'
        },
        {id: 13, datum: '23.07.2022 17 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 14,
          datum: '23.07.2022 18 Uhr',
          veranstaltung: 'Grillparty im Hause Wenzel (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Anmeldung erforderlich'
        },
        {id: 15, datum: '26.08.2022 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 16,
          datum: '26.08.2022 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>Zur Linde</i>',
          bemerkung: ''
        },
      ],
      fieldsWS19: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsWS19: [

        {id: 1, datum: '08.10.2019 19 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 2,
          datum: '12.10.2019 gt.',
          veranstaltung: 'Herbstwanderung (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 3,
          datum: '19.10.2019 19 Uhr',
          veranstaltung: 'Herbstpunch (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 4, datum: '23.11.2019 16 Uhr', veranstaltung: 'CC', bemerkung: ''},
        {id: 5, datum: '23.11.2019 20 Uhr', veranstaltung: 'Gründungstagskommers', bemerkung: ''},
        {id: 6, datum: '24.11.2019 11 Uhr', veranstaltung: 'Gräbergang', bemerkung: ''},
        {id: 7, datum: '24.11.2019 13 Uhr', veranstaltung: 'Ausklang im Walhall', bemerkung: ''},
        {id: 8, datum: '10.12.2019 19 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 9,
          datum: '15.12.2019 19 Uhr',
          veranstaltung: 'Weihnachtsessen (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 10,
          datum: '20.12.2019 19 Uhr',
          veranstaltung: 'Weihnachtsmarkt (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 11, datum: '10.01.2020 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 12,
          datum: '10.01.2020 19 Uhr',
          veranstaltung: 'Neujahrskegeln (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 13, datum: '14.02.2020 - 16.02.2020', veranstaltung: 'Skiausfahrt', bemerkung: ''},
        {id: 14, datum: '25.02.2020 19 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 15, datum: '14.03.2020 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 16, datum: '14.03.2020 20 Uhr', veranstaltung: 'Semesterabschlusskneipe', bemerkung: ''},
      ],
      fieldsSS19: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsSS19: [
        {
          id: 1,
          datum: '12.04.2019 20 Uhr',
          veranstaltung: 'Antrittskneipe',
          bemerkung: 'Achtung: Wurde vorverlegt auf Freitag'
        },
        {
          id: 2,
          datum: '18.05.2019 17 Uhr',
          veranstaltung: 'Spargelessen (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Achtung: Verschoben auf den 25.05.'
        },
        {
          id: 3,
          datum: '18.05.2019 20 Uhr',
          veranstaltung: 'Damenkneipe (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Achtung: Verschoben auf den 25.05.'
        },
        {
          id: 4,
          datum: '22.06.2019 18 Uhr',
          veranstaltung: 'Grillparty (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 5, datum: '29.06.2019 20 Uhr', veranstaltung: 'Großer Kartelltag', bemerkung: ''},
        {
          id: 6,
          datum: '13.07.2019 11 Uhr',
          veranstaltung: 'Exkursion ins Elsass (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Anmeldung erforderlich'
        },
        {
          id: 7,
          datum: '13.07.2019 17 Uhr',
          veranstaltung: 'Flammkuchenessen (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'Anmeldung erforderlich'
        },
        {
          id: 8,
          datum: '17.08.2019 12 Uhr',
          veranstaltung: 'Exkursion nach Mannheim (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 9,
          datum: '17.08.2019 19 Uhr',
          veranstaltung: 'Bierverkostung im Taproom Mannheim (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 10, datum: '24.08.2019 20 Uhr', veranstaltung: 'Semesterabschlusskneipe', bemerkung: ''},
      ],
      fieldsSS20: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsSS20: [
        {id: 1, datum: '12.06.2020 20 Uhr', veranstaltung: 'Abikneipe'},
        {id: 2, datum: '05.09.2020 18 Uhr', veranstaltung: 'Grillen bei AH Wenzel', bemerkung: ''},
        {id: 3, datum: '05.09.2020 19 Uhr', veranstaltung: 'Sommer-Kneipe mit Grillen', bemerkung: ''},
      ],
      fieldsWS20: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsWS20: [
        {id: 1, datum: '08.10.2020 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 2, datum: '08.10.2020 19 Uhr', veranstaltung: 'Stammtisch im Restaurant <i>Ponyhof</i>', bemerkung: ''},
        {
          id: 3,
          datum: '30.10.2020 19 Uhr',
          veranstaltung: 'Weinprobe im digitalen Raum (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 4,
          datum: '05.11.2020 19 Uhr',
          veranstaltung: 'Stammtisch im Restaurant <i>Naturfreundehaus</i>',
          bemerkung: ''
        },
        {id: 5, datum: '21.11.2020 17 Uhr', veranstaltung: 'CC', bemerkung: ''},
        {
          id: 6,
          datum: '21.11.2020 20 Uhr',
          veranstaltung: 'Gründungstagskommers im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {
          id: 7,
          datum: '22.11.2020 11 Uhr',
          veranstaltung: 'Gräbergang',
          bemerkung: 'Treffen am Haupteingang Friedhof Bruchsal'
        },
        {
          id: 8,
          datum: '22.11.2020 13 Uhr',
          veranstaltung: 'Gemeinsames Mittagessen im Restaurant <i>Zum Bären</i>',
          bemerkung: ''
        },
        {
          id: 9,
          datum: '27.11. - 29.11.2020',
          veranstaltung: 'Gemeinsames Wochenende mit Turnerschaft Rhenopalatia',
          bemerkung: 'in Heidelberg, unter der Leitung von Bbr. Georg Gouvianakis'
        },
        {
          id: 10,
          datum: '20.12.2020 19 Uhr',
          veranstaltung: 'Weihnachtsessen im Restaurant <i>Zum Bären</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 11, datum: '15.01.2021 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 12,
          datum: '15.01.2021 19 Uhr',
          veranstaltung: 'Neujahrskegeln im <i>Kegelverein Ubstadt</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 13, datum: '28.01.2021 19 Uhr', veranstaltung: 'Stammtisch im Restaurant <i>Ponyhof</i>', bemerkung: ''},
        {
          id: 14,
          datum: '06.02.2021 19 Uhr',
          veranstaltung: 'Frühjahrswanderung (<span style="color:red;">&hearts;</span>)',
          bemerkung: 'unter der Leitung von Bbr. Max Fank'
        },
        {
          id: 15,
          datum: '04.03.2021 19 Uhr',
          veranstaltung: 'Stammtisch im Restaurant <i>Naturfreundehaus</i>',
          bemerkung: ''
        },
        {id: 16, datum: '13.03.2021 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 17,
          datum: '13.03.2021 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
      ],
      fieldsSS21: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsSS21: [
        {id: 1, datum: '27.08.2021 19 Uhr', veranstaltung: 'AC/BC'},
        {
          id: 2,
          datum: '27.08.2021 20 Uhr',
          veranstaltung: 'Kneipe zur Wiederaufnahme des Bundeslebens in der Linde',
          bemerkung: ''
        },
      ],
      fieldsWS21: [
        {
          key: 'datum'
        },
        {
          key: 'veranstaltung'
        },
        {
          key: 'bemerkung'
        },
      ],
      itemsWS21: [
        {id: 1, datum: '02.10.2021 19 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 2,
          datum: '02.10.2021 20 Uhr',
          veranstaltung: 'Semesterantrittskneipe im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {
          id: 3,
          datum: '15.10.2021 19 Uhr',
          veranstaltung: 'Herbstpunch <i>im Hause Bretschneider</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 4, datum: '30.10.2021', veranstaltung: 'Aktiventag', bemerkung: ''},
        {id: 5, datum: '16.11.2021 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 6,
          datum: '19.11.2021 19 Uhr',
          veranstaltung: 'Begrüßungsabend (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 7,
          datum: '20.11.2021 11 Uhr',
          veranstaltung: 'Matinée <i>Schloss Bruchsal im Kammermusiksaal</i>  (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {
          id: 8,
          datum: '20.11.2021 20 Uhr',
          veranstaltung: 'Festkommers <i>Schloss Bruchsal im Gartensaal</i>',
          bemerkung: ''
        },
        {
          id: 9,
          datum: '21.11.2021 11 Uhr',
          veranstaltung: 'Gräbergang',
          bemerkung: 'Treffen am Haupteingang Friedhof Bruchsal'
        },
        {
          id: 10,
          datum: '21.11.2021 12 Uhr',
          veranstaltung: 'Gemeinsames Mittagessen im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {
          id: 11,
          datum: '19.12.2021 19 Uhr',
          veranstaltung: 'Weihnachtsessen im Restaurant <i>Zum Bären</i> (<span style="color:red;">&hearts;</span>)',
          bemerkung: ''
        },
        {id: 12, datum: '07.01.2022 18 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {id: 13, datum: '07.01.2022 19 Uhr', veranstaltung: 'Neujahrskegeln', bemerkung: ''},
        {id: 14, datum: '22.01.2022 17 Uhr', veranstaltung: 'CC', bemerkung: ''},
        {
          id: 15,
          datum: '22.01.2022 20 Uhr',
          veranstaltung: 'Conventskneipe im Restaurant <i>Belvedere</i>',
          bemerkung: ''
        },
        {
          id: 16,
          datum: '11.02.2022 - 13.02.2022',
          veranstaltung: 'PV Bund Skiausfahrt',
          bemerkung: 'unter der Leitung von Bbr. AH Bretschneider'
        },
        {id: 17, datum: '12.03.2022 19 Uhr', veranstaltung: 'AC/BC', bemerkung: ''},
        {
          id: 18,
          datum: '12.03.2022 20 Uhr',
          veranstaltung: 'Semesterabschlusskneipe im Restaurant <i>Zur Linde</i>',
          bemerkung: ''
        },
      ],
    }
  }
}
</script>
